import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FileText, Package, Truck } from "lucide-react";
import { Quotations } from "./Quotations";
import { SalesOrders } from "./SalesOrders";
import { DeliveryOrders } from "./DeliveryOrders";

const SalesDocuments = () => {
  const [activeTab, setActiveTab] = React.useState("quotations");

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl font-bold">Sales Documents</CardTitle>
      </CardHeader>
      <CardContent>
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="grid w-full grid-cols-3 mb-6">
            <TabsTrigger value="quotations" className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              Quotations
            </TabsTrigger>
            <TabsTrigger value="sales-orders" className="flex items-center gap-2">
              <Package className="h-4 w-4" />
              Sales Orders
            </TabsTrigger>
            <TabsTrigger value="delivery-orders" className="flex items-center gap-2">
              <Truck className="h-4 w-4" />
              Delivery Orders
            </TabsTrigger>
          </TabsList>

          <TabsContent value="quotations">
            <Quotations />
          </TabsContent>

          <TabsContent value="sales-orders">
            <SalesOrders />
          </TabsContent>

          <TabsContent value="delivery-orders">
            <DeliveryOrders />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default SalesDocuments;
